import type { UserRole } from 'types/role';
import type { EnrichedUser, User } from 'types/user';

export const buildEnrichedUser = (
  user: User,
  roleById: Partial<{ [key: number]: UserRole }>
): EnrichedUser => {
  return {
    ...user,
    role_name: roleById[user.role_id]?.display_name || 'Unknown',
  };
};
